const EDGE_TOLERANCE = 2;
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function initScroller(root) {
  const track = root.querySelector('[data-hd-scroller-track]');
  const prevBtn = root.querySelector('[data-hd-scroller-prev]');
  const nextBtn = root.querySelector('[data-hd-scroller-next]');
  if (!(track instanceof HTMLElement)) return;

  const step = () => {
    const first = track.querySelector('[data-hd-scroller-item]');
    const w = first instanceof HTMLElement ? first.offsetWidth : 240;
    const gap = parseFloat(getComputedStyle(track).columnGap || '16') || 16;
    return w + gap;
  };

  const page = () => {
    const s = step();
    const fixed = parseInt(root.dataset.hdScrollerStep || '', 10);
    if (Number.isFinite(fixed) && fixed > 0) return fixed * s;
    const per = Math.max(1, Math.floor(track.clientWidth / s));
    return per * s;
  };

  const syncArrows = () => {
    const max = track.scrollWidth - track.clientWidth;
    root.classList.toggle('hd-scroller--has-arrows', max > EDGE_TOLERANCE);

    const looping = track.dataset.hdMarquee === 'on';
    if (prevBtn instanceof HTMLButtonElement) {
      prevBtn.disabled = !looping && track.scrollLeft <= EDGE_TOLERANCE;
    }
    if (nextBtn instanceof HTMLButtonElement) {
      nextBtn.disabled = !looping && track.scrollLeft >= max - EDGE_TOLERANCE;
    }
  };

  const nudge = (direction) => {
    const left = direction * page();
    root.dispatchEvent(new CustomEvent('hd-scroller:jump', { detail: { left } }));
    track.scrollBy({ left, behavior: 'smooth' });
  };

  prevBtn?.addEventListener('click', () => nudge(-1));
  nextBtn?.addEventListener('click', () => nudge(1));

  track.addEventListener('scroll', syncArrows, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(syncArrows).observe(track);
  else window.addEventListener('resize', syncArrows);

  if ('MutationObserver' in window) {
    new MutationObserver(syncArrows).observe(track, {
      attributes: true,
      attributeFilter: ['data-hd-marquee'],
    });
  }

  syncArrows();

  const interval = parseInt(root.dataset.autoscroll || '', 10);
  if (!interval || reduceMotion.matches) return;

  let timer = null;
  let paused = false;

  const advance = () => {
    if (paused) return;
    const max = track.scrollWidth - track.clientWidth;
    if (max <= EDGE_TOLERANCE) return;

    if (track.scrollLeft >= max - EDGE_TOLERANCE) {

      track.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    }
  };

  const start = () => {
    if (timer) return;
    timer = window.setInterval(advance, interval);
  };
  const stop = () => {
    if (!timer) return;
    window.clearInterval(timer);
    timer = null;
  };

  const pause = () => { paused = true; };
  const resume = () => { paused = false; };

  root.addEventListener('mouseenter', pause);
  root.addEventListener('mouseleave', resume);
  root.addEventListener('focusin', pause);
  root.addEventListener('focusout', (e) => {
    if (e.relatedTarget instanceof Node && root.contains(e.relatedTarget)) return;
    resume();
  });
  track.addEventListener('pointerdown', pause);
  window.addEventListener('pointerup', resume);

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop();
    else start();
  });

  reduceMotion.addEventListener('change', (e) => {
    if (e.matches) stop();
    else start();
  });

  start();
}

document.querySelectorAll('[data-hd-scroller]').forEach((el) => {
  if (el instanceof HTMLElement) initScroller(el);
});
